import I18n from 'I18n';
import { getPlainText, getRichText
// @ts-expect-error - Missing declaration file for conversations-message-history module
} from 'conversations-message-history/common-message-format/operators/commonMessageFormatGetters';
import { OFFICE_HOURS } from 'conversations-message-history/office-hours-message/constants/messageTypes';
// @ts-expect-error - Missing declaration file for conversations-message-history module
import { hasTextContent } from 'conversations-message-history/web/common-message/operators/hasTextContent';
import ContentText from '../atoms/ContentText';
import DashedLabel from '../atoms/DashedLabel';
// @ts-expect-error - Untyped import
import { isDuringOfficeHours } from './operators/isDuringOfficeHours';

// "Message" is an untyped record from conversations-internal-schema,
// will revisit this when we migrate to TypeScript
import { jsx as _jsx } from "react/jsx-runtime";
const AvailabilityMessage = ({
  message
}) => {
  if (message['@type'] !== OFFICE_HOURS && !hasTextContent(message)) {
    return null;
  }
  if (isDuringOfficeHours(message)) return null;
  return /*#__PURE__*/_jsx(DashedLabel, {
    transparent: true,
    labelPadding: "m-y-1",
    children: /*#__PURE__*/_jsx(ContentText, {
      messageId: message.id,
      "aria-label": `${I18n.text('conversations-visitor-message-history.systemMessage')} ${getPlainText(message)}`,
      contentText: getRichText(message) || getPlainText(message),
      isPartialMessage: false
    })
  });
};
AvailabilityMessage.displayName = 'AvailabilityMessage';
export default AvailabilityMessage;